// extracted by mini-css-extract-plugin
export default {"hideTooltip":"U9-z","fadeIn":"V9-z","delay":"W9-z","recommendedSizeTooltip":"X9-z"};